export function SymbolLogoCreatePanelWrapper() {

  return <div>SymbolLogoCreatePanelWrapper</div>
}